<template>
  <div v-if="isStripeLoaded" class="flex flex-col">
    <WalletButtons />
    <CardOnFilePayment />
    <OtherPayment />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import WalletButtons from './WalletButtons.vue'
import CardOnFilePayment from '@/components/CardOnFilePayment.vue'
import OtherPayment from './OtherPayment.vue'
import { useStripeStore } from '@/stores/stripe'

const stripeStore = useStripeStore()
const isStripeLoaded = computed(() => !stripeStore.isLoading)
</script>

<style></style>
